import React from 'react';
import { motion } from 'framer-motion';
import { Loader2, Terminal, BrainCircuit, CheckCircle2 } from 'lucide-react';
export type StatusType = 'thinking' | 'tool' | 'complete';
interface StatusIndicatorProps {
  type: StatusType;
  label: string;
  isExpanded?: boolean;
}
export function StatusIndicator({
  type,
  label,
  isExpanded = false
}: StatusIndicatorProps) {
  // Force expansion for the thinking type in this showcase to see the UI
  const shouldExpand = isExpanded || type === 'thinking';
  const icons = {
    thinking: <BrainCircuit size={14} className="text-blue-500" data-id="element-58" />,
    tool: <Terminal size={14} className="text-slate-500 dark:text-slate-400" data-id="element-59" />,
    complete: <CheckCircle2 size={14} className="text-emerald-500" data-id="element-60" />
  };
  return <motion.div initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} className="flex flex-col gap-2 my-2" data-id="element-61">
      <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 w-fit ${type !== 'complete' ? 'animate-pulse' : ''}`} data-id="element-62">
        {type === 'thinking' || type === 'tool' && !isExpanded ? <Loader2 size={14} className="animate-spin text-slate-400" data-id="element-63" /> : icons[type]}
        <span className="text-xs font-medium text-slate-600 dark:text-slate-300" data-id="element-64">
          {label}
        </span>
      </div>

      {shouldExpand && type === 'thinking' && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} className="pl-4 border-l-2 border-slate-100 dark:border-slate-800 ml-4 py-1" data-id="element-65">
          <p className="text-xs text-slate-400 dark:text-slate-500 italic" data-id="element-66">
            Analyzing request and searching relevant context...
          </p>
        </motion.div>}
    </motion.div>;
}